module.exports = __webpack_public_path__ + "img/solution_3.703e7659.png";